//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageModal from "@/components/objects/ImageModal.vue";
import IconView from "@/components/objects/IconView.vue";
import { BUILD_STORAGE_IMAGE_PATH, LIST_COLORS } from "@/constants/ui.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "ImageAttrMinimalism",
  components: { IconView },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    objectId: {
      type: String,
      default: ""
    },
    listInfo: {
      type: Object,
      default: () => ({})
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: "links_images_minimalism"
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => ({})
    },
    template: {
      type: Object,
      default: null
    },
    theme: {
      type: String,
      default: ""
    },
    user: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      colors: [...LIST_COLORS],
    }
  },
  computed: {
    visibleItems() {
      return (this.items || []).filter(item => !item.is_deleted)
    },
    objectLabel() {
      return this.listInfo?.object_label || this.listInfo?.label || ""
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    blockBorderPalette() {
      return this.getPalette(this.design_extra?.block_border?.palette)
    },
    iconBorderPalette() {
      return this.getPalette(this.design_extra?.icon_border?.palette)
    },
    iconBgPalette() {
      return this.getPalette(this.design_extra?.icon_bg?.palette)
    },
    getTextColor() {
      return this.design_extra?.text?.color || "#212121";
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color || this.getTextColor;
    },
    getFirstBlockBorderColor() {
      return this.design_extra?.first_block?.block_border_color || this.getBlockBorderColor(0) || "#d7d7d7";
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color || "black";
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled || null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction || "bottom";
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction || "transparent";
    },
  },
  methods: {
    getPalette(paletteId) {
      if (!paletteId || !this.paletteList) return null;
      return this.paletteList.find(el => el.id === paletteId) || null;
    },
    getPaletteColor(palette, index) {
      if (!palette) return null;
      const colors = [palette.main_color, ...palette.colors];
      return colors[index % colors.length];
    },
    getBlockBorderColor(index) {
      return this.getPaletteColor(this.blockBorderPalette, index) || this.design_extra?.block_border?.color || null;
    },
    getIconBorderColor(index) {
      return this.getPaletteColor(this.iconBorderPalette, index) || this.design_extra?.icon_border?.color || null;
    },
    getIconBg(index) {
      const color = this.getPaletteColor(this.iconBgPalette, index) || this.design_extra?.icon_bg?.color || null;

      if (!color) return null;

      if (this.getIconGradientEnabled) {
        const secondColor = this.getIconGradientShadowDirection === 'transparent' ? 'transparent' : adjustColorBrightness(color, 1.20);
        return `linear-gradient(to ${this.getIconGradientDirection}, ${color}, ${secondColor})`
      }

      return color;
    },
    getItemText(item) {
      return item.fullText || item.shortText || item.text || "";
    },
    imagePath(item) {
      if (this.useStorage && item.image_file) {
        return BUILD_STORAGE_IMAGE_PATH(item.image_file)
      }

      // if (item.image_file) {
      //   return BUILD_STORAGE_IMAGE_PATH(item.image_file)
      // }

      return `/public/object_attrs_files/${this.objectId}/${item.id}/`
    },
    isLastOdd(index) {
      return this.visibleItems.length % 2 === 1 && index === this.visibleItems.length - 1;
    },
    openPopup(item) {
      if (item.image_type !== 'image') return;

      this.$vfm.show({
        component: ImageModal,
        bind: {
          src: this.$addServerPath(this.imagePath(item)),
          label: item.label || "Без названия",
          source: item.image_url
        },
      })
    },
  }
}
